import type { ReactNode } from "react";
import { Button } from "react-bootstrap";

import { MoneyIcon, PercentageIcon } from "../../../../components/icons";

export interface UsageTierItemProps {
  type: number;
  icon: ReactNode;
  isCurrent: boolean;
  title: string;
  range: string;
  discount: string;
  upgrade?: string;
  isLast?: boolean;
  openModal?: () => void;
}

const UsageTierItem = ({
  icon,
  isCurrent,
  title,
  range,
  discount,
  upgrade,
  isLast,
  openModal,
}: UsageTierItemProps) => {
  return (
    <div
      className={`tier-item ${isCurrent ? "" : "next"} ${isLast ? "last" : ""}`}
    >
      <div className="tier-step">
        {isCurrent ? icon : <div className="tier-dot" />}
      </div>
      <div className="tier-info=wrap">
        <div className="tier-type">
          {isCurrent ? "Current tier" : "Next tier"}
        </div>
        <div className="tier-info-title">{title}</div>
        <div className="tier-info">
          <div>
            <MoneyIcon />
            {range}
          </div>
          <div>
            <PercentageIcon />
            {discount}
          </div>
        </div>
        {isCurrent && (
          <>
            <p className="billing__caption">{upgrade}</p>
            <Button
              onClick={openModal}
              className="prices-button"
              variant="link"
            >
              View prices
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export { UsageTierItem };
